module.exports = __webpack_public_path__ + "static/web-incentivized-traffic-1477ea55da64e363625dc1f836f96a5a.gif";